





















import { isNil } from 'lodash';
import { Component, Prop, Watch, Vue, Model } from 'vue-property-decorator';

@Component
export default class FieldTagInput extends Vue {
  @Model('update') public outcome_tag!: string[];
  @Prop({ type: String }) public placeholder!: string;
  @Prop({ type: Boolean, default: false }) public disabled?: boolean;

  public tag_input: string = '';

  public beforeMount() {
    this.loadListOutcomeTag();
  }

  public loadListOutcomeTag() {
    if (isNil(this.outcome_tag)) {
      this.outcome_tag = [];
    }
  }

  @Watch('outcome_tag')
  public setValue() {
    this.$emit('update', this.outcome_tag);
  }

  public addTag(event) {
    event.preventDefault();
    var val = event.target.value.trim();
    if (val.length > 0) {
      this.outcome_tag.push(val);
      this.tag_input = '';
    }
  }

  public removeTag(index) {
    this.outcome_tag.splice(index, 1);
  }

  public removeLastTag(event) {
    if (event.target.value.length === 0) {
      this.removeTag(this.outcome_tag.length - 1);
    }
  }
}
